import { useEffect, useState } from 'react';

export function useCenterTip(duration = 2000) {
  const [text, setText] = useState<string | null>(null);

  useEffect(() => {
    if (!text) return;
    const timer = setTimeout(() => setText(null), duration);
    return () => clearTimeout(timer);
  }, [text, duration]);

  const CenterTip = text ? (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          padding: '8px 16px',
          background: 'rgba(0,0,0,0.75)',
          color: '#fff',
          borderRadius: 6,
          fontSize: 14,
        }}
      >
        {text}
      </div>
    </div>
  ) : null;

  return {
    show: (msg: string) => setText(msg),
    CenterTip,
  };
}
